import Axios from "axios";
import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../../config';
import {
    THEODORE_GET_EMAIL_OTP,
    theodoreGetEmailOtpSuccess,
    theodoreGetEmailOtpFailure,
    THEODORE_RESET_PASSWORD,
    theodoreResetPasswordSuccess,
    theodoreResetPasswordFailure
} from './action';

export function* getEmailOtp(action) {
    let requestURL = `${AUTH_SERVER}/theodore/pwdreset`;
    try {
        const result = yield call(Axios.post, requestURL, action.data);
        yield put(theodoreGetEmailOtpSuccess(result.data));
    } catch (err) {
        yield put(theodoreGetEmailOtpFailure(err))
    }
}
export function* theodoreGetEmailOtp() {
    yield takeLatest(THEODORE_GET_EMAIL_OTP, getEmailOtp);
}

export function* userResetPassword(action) {
    let requestURL = `${AUTH_SERVER}/theodore/pwdreset/${action.data.email}`;
    try {
        const result = yield call(Axios.post, requestURL, action.data.requestBody);
        yield put(theodoreResetPasswordSuccess(result.data));
    } catch (err) {
        yield put(theodoreResetPasswordFailure(err))
    }
}
export function* theodoreResetPassword() {
    yield takeLatest(THEODORE_RESET_PASSWORD, userResetPassword);
}